export const DEFAULT_ITEMS_PER_PAGE = [18, 27, 36, 54];
